export const PRODUCTS_CHANGED = 'product-bundle.products-changed';
export const ADD_TO_CART_ANALYTICS = 'bundle-mini.bipAddToCart';
export const BIP_TO_PIP_PRODUCT_VIEW = 'bundle-mini.viewBundleClick';
export const PRODUCT_BUNDLE_PRODUCT_LIST_ITEM_CLICK = 'product-bundle.productListItemClick';
export const PRODUCT_BUNDLE_ACCORDION_OPEN = 'product-bundle.open-accordion';